import React from 'react';
import { useDispatch } from 'react-redux';
import Txt from 'components/inputs/textInput.js';
import { Dropdown, Checkbox, Button, Icon } from 'semantic-ui-react';
import Lbl from 'components/inputs/label.js';
import objectAssign from 'object-assign';
import { clone } from 'reducers/helper.js';
import { updateWaitingAreaOperatingHoursForm } from 'actions/waitingArea.js';
import { ValidMe } from 'businessLogic/validation.js';
import {
  timeOptionStart,
  timeOptionEnd,
  serviceOfferingAvailabilityTemplate,
  getTimeOptionEnd,
} from '../../../../businessLogic/operatingDaysAndHours';

export default function CenterPanelUpdate(props) {
  const dispatch = useDispatch();
  const OperatingHoursUpdated = (property, value, index) => {
    let operatingHoursForm = clone(props.waitingAreaOperatingHoursForm);
    operatingHoursForm.serviceOfferingAvailabilities[index][property] = value;
    dispatch(updateWaitingAreaOperatingHoursForm(operatingHoursForm));
  };

  const OperatingHoursDayChanged = (value, dayNumber, index) => {
    switch (dayNumber) {
      case 0:
        OperatingHoursUpdated('isMondaySelected', value, index);
        break;
      case 1:
        OperatingHoursUpdated('isTuesdaySelected', value, index);
        break;
      case 2:
        OperatingHoursUpdated('isWednesdaySelected', value, index);
        break;
      case 3:
        OperatingHoursUpdated('isThursdaySelected', value, index);
        break;
      case 4:
        OperatingHoursUpdated('isFridaySelected', value, index);
        break;
      case 5:
        OperatingHoursUpdated('isSaturdaySelected', value, index);
        break;
      case 6:
        OperatingHoursUpdated('isSundaySelected', value, index);
        break;
    }
  };

  const timezoneChanged = (i, v) => {
    let operatingHoursForm = objectAssign({}, props.waitingAreaOperatingHoursForm, {
      ['serviceTimeZone']: v.value,
    });
    dispatch(updateWaitingAreaOperatingHoursForm(operatingHoursForm));
  };

  const fromTimeChange = (e, v, index) => {
    console.log('timeOptionStart timeOptionStart', timeOptionStart);

    let operatingHoursForm = clone(props.waitingAreaOperatingHoursForm);

    const endTimeValue = operatingHoursForm.serviceOfferingAvailabilities[index].toTime;
    let startTimeIndex = timeOptionStart.findIndex((x) => {
      return x.value == v.value;
    });
    let endTimeIndex = timeOptionEnd.findIndex((x) => {
      return x.value == endTimeValue;
    });

    console.log('timeOptionEnd timeOptionEnd', endTimeIndex);
    if (endTimeIndex < startTimeIndex) {
      operatingHoursForm.serviceOfferingAvailabilities[index].toTime = timeOptionEnd[startTimeIndex].value;
    }

    operatingHoursForm.serviceOfferingAvailabilities[index].fromTime = v.value;
    // timeOptionEnd
    dispatch(updateWaitingAreaOperatingHoursForm(operatingHoursForm));
  };

  const toTimeChange = (e, v, index) => {
    let operatingHoursForm = clone(props.waitingAreaOperatingHoursForm);
    operatingHoursForm.serviceOfferingAvailabilities[index].toTime = v.value;
    dispatch(updateWaitingAreaOperatingHoursForm(operatingHoursForm));
  };

  const addNewSeviceAvailability = () => {
    let operatingHoursForm = clone(props.waitingAreaOperatingHoursForm);
    operatingHoursForm.serviceOfferingAvailabilities.push(serviceOfferingAvailabilityTemplate);
    dispatch(updateWaitingAreaOperatingHoursForm(operatingHoursForm));
  };
  const removeAvailibilty = (index) => {
    let operatingHoursForm = clone(props.waitingAreaOperatingHoursForm);
    operatingHoursForm.serviceOfferingAvailabilities.splice(index, 1);
    dispatch(updateWaitingAreaOperatingHoursForm(operatingHoursForm));
  };

  return (
    <span>
      <div className="ui form">
        <div className="mrbm">
          <label className="placeholder-label no-bold color-placeholder div-like">
            {APP.LANGUAGE.WaitingAreaOperatingHours.TimezoneTitle}
          </label>
          <Txt
            text="text"
            value="value"
            semanticui
            normal
            dropdown
            selectedValue={props.waitingAreaOperatingHoursForm.serviceTimeZone}
            options={props.timezones}
            onChange={timezoneChanged}
          />
        </div>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaOperatingHours.AvailableTimeTitle}
        </label>

        {props.waitingAreaOperatingHoursForm.serviceOfferingAvailabilities.map((soAvailibilty, i) => {
          return (
            <div key={i}>
              <div className="available-time-area pdbxxs">
                <div className=" fl time-area">
                  <div className="time-slots fl mrbxs mrtxs">
                    <div className=" mrlxs  hide-on-tablet-ress hide-on-small-ress">
                      {APP.LANGUAGE.WaitingAreaOperatingHours.timeFrom}
                    </div>
                    <Txt
                      className="small-dropdown mrlxs"
                      text="text"
                      value="value"
                      extraParam={i}
                      semanticui
                      normal
                      noSearch={true}
                      dropdown
                      selectedValue={soAvailibilty.fromTime}
                      options={timeOptionStart}
                      onChange={fromTimeChange}
                    />
                    <div className=" mrrxs mrlm hide-on-small-ress">
                      {APP.LANGUAGE.WaitingAreaOperatingHours.timeTo}
                    </div>
                    <div className=" mrrxs mrlm show-on-small-ress text-size-mms">
                      {APP.LANGUAGE.WaitingAreaOperatingHours.timeTo}
                    </div>
                    <Txt
                      className="small-dropdown"
                      text="text"
                      value="value"
                      semanticui
                      normal
                      dropdown
                      noSearch={true}
                      selectedValue={soAvailibilty.toTime}
                      extraParam={i}
                      options={getTimeOptionEnd(soAvailibilty.fromTime)}
                      onChange={toTimeChange}
                    />
                  </div>
                  <div className="fr pdrxs pdtxs  hide-on-tablet-ress hide-on-small-ress " data-show={i > 0}>
                    <Button
                      onClick={() => {
                        removeAvailibilty(i);
                      }}
                      icon
                      className="color-bad-things circular super-mini "
                    >
                      <Icon name="remove" className="icon color-white" />{' '}
                    </Button>
                  </div>
                  <div className="fr pdrxs  pdtxs show-on-tablet-ress" data-show={i > 0}>
                    <Button
                      onClick={() => {
                        removeAvailibilty(i);
                      }}
                      icon
                      className="color-bad-things circular super-mini "
                    >
                      <Icon name="remove" className="icon color-white" />{' '}
                    </Button>
                  </div>
                  <div className="fr pdrxs  pdtxs show-on-small-ress" data-show={i > 0}>
                    <Button
                      onClick={() => {
                        removeAvailibilty(i);
                      }}
                      icon
                      className="color-bad-things circular super-mini "
                    >
                      <Icon name="remove" className="icon color-white" />{' '}
                    </Button>
                  </div>
                </div>
                <div className="pdlxs">
                  <div className="  show-on-desktop-ress ">
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.MondayText}
                      className="weekDayCheckBox weekDayCheckBoxSmall"
                      checked={soAvailibilty.isMondaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 0, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayText}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isTuesdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 1, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayText}
                      className="weekDayCheckBox mrrml"
                      checked={soAvailibilty.isWednesdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 2, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayText}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isThursdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 3, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.FridayText}
                      className="weekDayCheckBox weekDayCheckBoxSmall"
                      checked={soAvailibilty.isFridaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 4, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayText}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isSaturdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 5, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.SundayText}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isSundaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 6, i);
                      }}
                    />
                  </div>

                  <div className=" show-on-tablet-ress">
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.MondayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isMondaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 0, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isTuesdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 1, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isWednesdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 2, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isThursdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 3, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.FridayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isFridaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 4, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isSaturdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 5, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.SundayShort}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isSundaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 6, i);
                      }}
                    />
                  </div>
                  <div className=" show-on-small-ress">
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.MondayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isMondaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 0, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isTuesdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 1, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isWednesdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 2, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isThursdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 3, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.FridayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isFridaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 4, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isSaturdaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 5, i);
                      }}
                    />
                    <Checkbox
                      label={APP.LANGUAGE.WaitingAreaOperatingHours.SundayMini}
                      className="weekDayCheckBox"
                      checked={soAvailibilty.isSundaySelected}
                      onChange={(e, v) => {
                        OperatingHoursDayChanged(v.checked, 6, i);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mrbs" />
            </div>
          );
        })}
        <div className="mrbs placeholder-label">
          <span>{APP.LANGUAGE.WaitingAreaOperatingHours.helpText}</span>
        </div>
        <div>
          <Button className="tiny circular" icon onClick={addNewSeviceAvailability}>
            <Icon name="plus" />
          </Button>
          <span className="pdlxs">Add another time</span>
        </div>
      </div>
    </span>
  );
}
